/**
 * Promotional Modal for Translate Press.Zone
 *
 * Shows a feature overview and CTA when TPZ is not installed or configured.
 *
 * @package MultilingualPressZone
 */

import { el, __ } from './dom.js';
import Modal from '../components/Modal.js';
import { Button } from '../components/Button.js';

/**
 * Show the translate promo modal
 */
export function showTranslatePromoModal() {
    const modal = new Modal({
        title: __('Auto-Generate Translations with AI', 'multilingual-press-zone'),
        width: '520px',
        id: 'mpz-translate-promo-modal',
    });

    const content = el('div', { class: 'mpz-promo-modal' },
        el('div', { class: 'mpz-promo-modal__icon' }, '\uD83C\uDF10'),
        el('h3', { class: 'mpz-promo-modal__heading' },
            __('AI-Powered Translation', 'multilingual-press-zone')
        ),
        el('p', { class: 'mpz-promo-modal__description' },
            __('Generate high-quality translations instantly with the Translate Press.Zone plugin. Powered by advanced AI models, it handles 100+ languages while preserving your HTML formatting.', 'multilingual-press-zone')
        ),
        el('ul', { class: 'mpz-promo-modal__features' },
            el('li', {}, __('AI-powered translations with context awareness', 'multilingual-press-zone')),
            el('li', {}, __('Support for 100+ languages', 'multilingual-press-zone')),
            el('li', {}, __('HTML tag and formatting preservation', 'multilingual-press-zone')),
            el('li', {}, __('Pay-per-use character pricing', 'multilingual-press-zone'))
        )
    );

    const actions = [
        Button({
            label: __('Close', 'multilingual-press-zone'),
            variant: 'ghost',
            onClick: () => modal.close(),
        }),
        Button({
            label: __('Learn More', 'multilingual-press-zone'),
            variant: 'primary',
            onClick: () => {
                window.open('https://press.zone/plugins/translate/', '_blank', 'noopener,noreferrer');
            },
        }),
    ];

    modal.render(content, actions);
    modal.open();

    return modal;
}
